export const name = "HLL_COUNT.MERGE_PARTIAL";
export const summary = `Merges HLL++ sketches of the same underlying type into a new sketch.`;
export const reference = `
## HLL_COUNT.MERGE_PARTIAL

Merges HLL++ sketches of the same underlying type into a new sketch.

\`\`\`
HLL_COUNT.MERGE_PARTIAL(sketch)
\`\`\`

### Description

An aggregate function that takes one or more HLL++ \`sketch\`inputs and merges them into a new sketch.

Each \`sketch\` must be initialized on the same type. Attempts to merge sketches for different types results in an error. For example, you can't merge a sketch initialized from \`INT64\` data with one initialized from \`STRING\` data.

If the merged sketches were initialized with different precisions, the precision will be downgraded to the lowest precision involved in the merge. For example, if \`MERGE_PARTIAL\` encounters sketches of precision 14 and 15, the returned new sketch will have precision 14.

This function returns \`NULL\` if there is no input or all inputs are \`NULL\`.


### Supported input types

\`BYTES\`


### Return type

\`BYTES\`


### Example

The following query returns an HLL++ sketch that counts the number of distinct users who have at least one invoice across all countries.



\`\`\`
SELECT HLL_COUNT.MERGE_PARTIAL(HLL_sketch) AS distinct_customers_with_open_invoice
FROM
  (
    SELECT
      country,
      HLL_COUNT.INIT(customer_id) AS hll_sketch
    FROM
      UNNEST(
        ARRAY<STRUCT<country STRING, customer_id STRING, invoice_id STRING>>[
          ('UA', 'customer_id_1', 'invoice_id_11'),
          ('BR', 'customer_id_3', 'invoice_id_31'),
          ('CZ', 'customer_id_2', 'invoice_id_22'),
          ('CZ', 'customer_id_2', 'invoice_id_23'),
          ('BR', 'customer_id_3', 'invoice_id_31'),
          ('UA', 'customer_id_2', 'invoice_id_24')])
    GROUP BY country
  );

/*----------------------------------------------------------------------------------------------*
 | distinct_customers_with_open_invoice |
 +----------------------------------------------------------------------------------------------+
 | "\\010p\\020\\006\\030\\002 \\013\\202\\007\\020\\020\\003\\030\\017 \\0242\\010\\320\\2408\\352}\\244\\223\\002" |
 *----------------------------------------------------------------------------------------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/hll_functions
`;
